<script>
  import Icon from '../ui/Icon.svelte'
  import svgCross from '../../public/icons/x-lg.svg'
  import svgCheck from "../../public/icons/check2.svg"
  import { modalAccept } from '../services/stores/modalAccept'
  import { _ } from '../services/i18n'

  import { fly } from 'svelte/transition'

  const cancelFunc = () => {
    if($modalAccept.cancel && typeof $modalAccept.cancel === 'function')
      $modalAccept.cancel()
    modalAccept.removeModal()
  }
  const acceptFunc = () => {
    $modalAccept.accept()
    modalAccept.removeModal()
  }

</script>

{#if $modalAccept.active}
<div class="overlay"></div>
<div class="modal-fade-show">
  <div transition:fly={{y: -200}} class="modal-dialog">
    <div class="modal-content">
      <header>
        {$modalAccept.message}
      </header>   
      <footer class='justify-center'>
        <button on:click={cancelFunc} style="display: flex; gap: 10px;" class="btn-3d" id="cancel-btn">
          <Icon svg={svgCross} class="icon-svg" strokeWidth="2px" color="var(--cancel-btn)"/>
          {#if $modalAccept.cancelText}
            {$modalAccept.cancelText}
          {:else}
            {$_('Cancel')}
          {/if}
        </button>
        <button on:click={acceptFunc} class="btn-3d" id="accept-btn">
          <Icon svg={svgCheck} class="icon-svg" style="width: 15px" color="var(--accept-btn)"/>
          {#if $modalAccept.acceptText}
            {$modalAccept.acceptText}
          {:else}
            {$_('Accept')}
          {/if}
        </button>
      </footer>
    </div>
  </div>
</div>
{/if}

<style>
  :root {
    --accept-btn: var(--theme-color-1);
    --cancel-btn: var(--theme-color-1);
  }

  #accept-btn:hover {
    --accept-btn: white;
    background-color: var(--theme-color-1);
  }

  #cancel-btn:hover {
    --cancel-btn: white;
    background-color: var(--theme-color-1);
  }

  #cancel-btn {
    color: var(--cancel-btn);
  } 
  #accept-btn {
    color: var(--accept-btn);
  }

  #accept-btn, #cancel-btn {
    background-color: transparent;
    border: 1px solid var(--theme-color-1);
    padding: 10px 30px;
    display: inline-flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    justify-content: space-around;
    min-width: 150px;
  }

  .overlay {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: #0008;
    z-index: 1000;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .modal-fade-show {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1060;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
  }

  .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: var(--theme-color-4);
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: .3rem;
    outline: 0;
  }
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
    position: relative;
    width: auto;
    pointer-events: none;
  }

  header {
    font-size: 17px;
    color: var(--theme-color-1);
    text-align: center;
    display: grid;
    align-content: center;
    text-transform: uppercase;
    letter-spacing: 1.7px;
    padding: 30px 15px;
  }

  /* button {
    border: 1px solid #ddd;
    border-radius: 5px;
    color: white;
    background-color: #2daae1;
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    margin: 0 !important;
    font-weight: 300;
    letter-spacing: 1.5px;
    padding: 5px 20px;
  }

  button:hover {
    background-color: var(--theme-color-4);
  } 

  .icon-btn {
    height: 15px;
    width:   15px;
    margin-right: 10px;
  }*/

  footer {
    display: inline-flex;
    margin-top: 0;
    justify-content: center;
    gap: 5px;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    align-items: flex-start;
    margin: 0 15px 15px;
    gap: 15px;
  }

</style>